import { render, staticRenderFns } from "./NixiaChat.vue?vue&type=template&id=96f1994e&scoped=true&"
import script from "./NixiaChat.vue?vue&type=script&lang=js&"
export * from "./NixiaChat.vue?vue&type=script&lang=js&"
import style0 from "./NixiaChat.vue?vue&type=style&index=0&id=96f1994e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f1994e",
  null
  
)

export default component.exports